import { render, staticRenderFns } from "./FaceCamera.vue?vue&type=template&id=006eec37&"
import script from "./FaceCamera.vue?vue&type=script&lang=js&"
export * from "./FaceCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports